<div class="form-wrapper">
  <div class="form-content size size1of1">
    <app-charge-loyalty-rules
      [_data]=data
      [_selectedChargeType]="_selectedChargeType"
      (_emitLoyaltyRules)="onGetLoyaltyRules($event)"
      (_emitLoyaltyErrors)="onGetLoyaltyRulesFormErrors($event)">
    </app-charge-loyalty-rules>
    <app-charge-prepaid-rules *ngIf="ratePlanTypeSelected === _ratePlanType.prepaid"
      [_data]=data
      [_selectedChargeType]="_selectedChargeType"
      (_emitPrepaidRules)="onGetPrepaidRules($event)"
      (_emitPrepaidErrors)="onGetPrepaidRulesFormErrors($event)">
    </app-charge-prepaid-rules>
    <app-charge-cutoff-rules *ngIf="data.isProduct"
      [_data]=data
      [_selectedChargeType]="_selectedChargeType"
      [_selectedBillCycleTypeValues]="_selectedBillCycleTypeValue"
      (_emitCutOffRules)="onGetCutOffRules($event)"
      (_emitCutOffErrors)="onGetCutOffRulesFormErrors($event)">
    </app-charge-cutoff-rules>
    <app-usage-based-rules
    (_emitChangeUsageBasedRules)="onChangeUsageBasedRules($event)"
    [_data]=data
    ></app-usage-based-rules>
      <div class="form-row row-checkbox border noborder-important">
        <mat-checkbox [disabled]="hasGiftRestriction"  [(ngModel)]="giftCharge" disableRipple="true" color="primary" class="custom-mat-checkbox checkbox-simple-line rounded" >
        <span class="flex typo semi-condensed fw400">Set this charge as a gift item
          <mat-icon
          matSuffix
          matTooltipPosition="right"
          matTooltipClass="mat-tooltip"
          matTooltip="Gift items are unique charge items that have a separate set of customer control permissions, so that by default, customers won’t be able to reschedule, change quantity, or even cancel their gift items"
          svgIcon="ico-help"
          class="custom-mat-icon ico-tooltip ico-size ico-2xs"></mat-icon>
        </span>
      </mat-checkbox>
      </div>


  </div>
</div>
